<ion-header>
  <app-header
    [isHome]="false"
    [logo]="merchant.merchantLogo"
    [sourceBanner]="merchant.merchantBanner"
    [merchantName]="'Stone Creek Coffee'"
    [merchantHeaderTitle]="merchant?.merchantHeaderTitle"
    [merchantHeaderText]="merchant?.merchantHeaderText"
    pageName="merchant"
    [showMerchantLogo]="true"
    [isCreek]="true"
  >
  </app-header>
</ion-header>

<ion-content>
  <div class="content">
    <ion-grid>
      <div class="heading" *ngIf="hasLoyaltyData">
        <p class="title">Coffee Geek Rewards</p>
        <div *ngIf="isVerifyCustomer; then points else phoneFieldTemplate"></div>
        <ng-template #points>
          <p>
            YOUR POINTS : {{ customer?.loyaltyPointsBalance || 0 }}
          </p>
        </ng-template>
        <ng-template #phoneFieldTemplate>
          <app-verify-phone-number [title]="title"
                                   (verificationCustomer)="customerVerification()"
                                   *ngIf="!verificationCustomer">
          </app-verify-phone-number>
        </ng-template>
        <p>REWARD TIERS</p>
      </div>

      <ion-row *ngIf="hasLoyaltyData">
        <ion-card *ngFor="let rewards of loyaltyRewards">
          <p class="bold-text">{{ rewards.name }}</p>
          <p>
            Any size with any modifiers -
            <span class="bold-text">{{ rewards.points }} POINTS</span>
          </p>
        </ion-card>
      </ion-row>

      <ion-row *ngIf="!hasLoyaltyData">
        <ion-card>
          <p class="bold-text">No loyalty points found</p>
        </ion-card>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
